import React from 'react';

const DescriptionSection = () => {
  return (
    <div className="text-center mb-12">
      <h2 className="text-4xl font-bold text-gray-900 mb-4">
        Get Your Restaurant's Reputation Audit
      </h2>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto">
        Discover your restaurant's online reputation score, customer insights, and actionable recommendations to
        improve your business.
      </p>
    </div>
  );
};

export default DescriptionSection;
